import { render, staticRenderFns } from "./todayComment.vue?vue&type=template&id=943a5582&scoped=true"
import script from "./todayComment.vue?vue&type=script&lang=js"
export * from "./todayComment.vue?vue&type=script&lang=js"
import style0 from "./todayComment.vue?vue&type=style&index=0&id=943a5582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943a5582",
  null
  
)

export default component.exports